module.exports = __webpack_public_path__ + "media/images/logo-rouge-8d981551cbd2ebc67962db9aeffeeb62.png";